import { render, staticRenderFns } from "./intFeePanel.vue?vue&type=template&id=f8a794a0&scoped=true&"
import script from "./intFeePanel.vue?vue&type=script&lang=js&"
export * from "./intFeePanel.vue?vue&type=script&lang=js&"
import style0 from "./intFeePanel.vue?vue&type=style&index=0&id=f8a794a0&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8a794a0",
  null
  
)

export default component.exports